<template>
  <div class="box" @click="clickedBox">
    <div class="block">
      <BInputWithValidation
        disabled
        type="text"
        label="Organisations Name"
        v-model="org(orgId).name"
      />
    </div>
    <div v-if="isPermited(['org_admin', 'admin'])" class="columns">
      <div class="column">
        <BInputWithValidation
          disabled
          type="text"
          label="Straße"
          v-model="org(orgId).street"
        />
      </div>
      <div class="column is-2">
        <BInputWithValidation
          disabled
          type="number"
          label="Nr."
          v-model="org(orgId).house_no"
        />
      </div>
      <div class="column is-2">
        <BInputWithValidation
          disabled
          type="text"
          label="Zusatz"
          v-model="org(orgId).street_additional"
        />
      </div>
    </div>
    <div v-if="isPermited(['org_admin', 'admin'])" class="columns">
      <div class="column is-3">
        <BInputWithValidation
          disabled
          type="text"
          label="PLZ"
          v-model="org(orgId).zip_code"
        />
      </div>
      <div class="column">
        <BInputWithValidation
          disabled
          type="text"
          label="Stadt"
          v-model="org(orgId).city"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import BInputWithValidation from '@/components/inputs/BInputWithValidation.vue';
// import BSelectWithValidation from '@/components/inputs/BSelectWithValidation.vue';

export default {
  name: 'OrgPreview',
  components: {
    BInputWithValidation,
    // BSelectWithValidation,
  },
  props: ['orgId'],
  computed: {
    ...mapGetters({
      org: 'org/dataById',
      meUser: 'user/me',
      isPermited: 'user/isPermited',
      isAdminActive: 'isAdminActive',
    }),
  },
  methods: {
    clickedBox() {
      if (this.isAdminActive) {
        this.$router.push({ name: 'ViewOrg', params: { orgId: this.orgId } });
      } else if (this.isPermited(['org_admin', 'admin'])) {
        this.$router.push({ name: 'OrgProfile' });
      }
    },
  },
};
</script>
